import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiSubmitTicketToZendesk,
  apiUploadFileToZendesk,
  apiSyncUserToZendesk,
} from '@dragonfruit/services/apis';

import {
  types,
  actions,
  getFiles,
  getReportOptions,
} from '@dragonfruit/redux/report';
import { actions as errorActions } from '@dragonfruit/redux/error';
import {
  getUserID,
  getUsername,
  getRegion as getUserRegionCode,
  getRole,
} from '@dragonfruit/redux/profile';

import { getRegion as getSiteRegionCode } from '@dragonfruit/redux/locale';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '@dragonfruit/constants/alertBannerThemes';
import { STUDENT } from '@dragonfruit/constants/userRoles';
import { DRAGON_FRUIT } from '@dragonfruit/constants/zendeskProjectTypes';

const INITIAL_OPTIONS = { showAlert: true, isReportToZendeskByAdmin: true };

export function* submitReportFlow(action) {
  const {
    email,
    reportMessage: message,
    options = INITIAL_OPTIONS,
  } = action.payload;
  const { projectName = DRAGON_FRUIT, tags } = yield select(getReportOptions);
  const userId = yield select(getUserID);
  const name = yield select(getUsername);
  const userRegionCode = yield select(getUserRegionCode);
  const siteRegionCode = yield select(getSiteRegionCode);
  const userRole = yield select(getRole);
  const files = yield select(getFiles);
  const { showAlert, isReportToZendeskByAdmin } = options;

  try {
    const tokens = files.map(file => file.token);
    const { data: { b2bEmailTitle: subjectTitle } = {} } = !!userId
      ? yield call(apiSyncUserToZendesk)
      : {};
    yield call(apiSubmitTicketToZendesk, {
      name,
      email,
      role: userRole || STUDENT,
      region: userRegionCode || siteRegionCode,
      userId,
      message,
      studentId: userId,
      projectName,
      tokens,
      subjectTitle,
      tags,
      isReportToZendeskByAdmin,
    });

    yield put(actions.submitReportSuccess());
    if (showAlert) {
      yield put(
        showAlertBanner({
          message: 'sdk:sdk.report.successMessage',
          theme: ALERT_SUCCESS_THEME,
        })
      );
    }
  } catch (err) {
    yield put(actions.submitReportFailed(err.message));
    if (showAlert) {
      yield put(
        showAlertBanner({
          message: err.message,
          theme: ALERT_ERROR_THEME,
        })
      );
    }
    yield put(errorActions.sendError(err));
  }
}

export function* uploadFileFlow(action) {
  const { file } = action.payload;
  try {
    const uploadedFile = yield call(apiUploadFileToZendesk, file);
    const newFile = {
      token: uploadedFile.token,
      name: uploadedFile.attachment.file_name,
      size: uploadedFile.attachment.size,
      isUploaded: true,
    };
    yield put(actions.uploadFileSuccess(newFile));
  } catch (err) {
    yield put(actions.uploadFileFailed(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([
    takeLatest(types.SUBMIT_REPORT_REQUEST, submitReportFlow),
    takeLatest(types.UPLOAD_FILE_REQUEST, uploadFileFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/report.js